export default function serviceWorkerDev() {
    if ('serviceWorker' in navigator) {
        let swUrl = `${process.env.PUBLIC_URL}/sw.js`
        navigator.serviceWorker.register(swUrl).then((response) => {
            console.warn("response", response)
        })
    }
}